import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
  KeyValuePair,
} from '@/shared/shared.types';
import { Field, RichTextField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C32IconCTAColoredBoxCardProps = RenderingProps<
  C32IconCTAColoredBoxCardFields,
  C32IconCTAColoredBoxCardRenderingParams
>;

export type C32IconCTAColoredBoxCardRenderingParams = {
  HeadlineType?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C32IconCTAColoredBoxCardFields = {
  Icon?: KeyValuePair;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CardCTA?: LinkField;
};
